import { enUS, ru } from 'date-fns/locale'
import type { Locale } from 'date-fns'
import i18n from '@/utils/i18n'

/**
 * Локаль date-fns под текущий язык интерфейса (ru ↔ enUS). Читает
 * `i18n.language` в момент вызова — компонент, форматирующий дату, должен
 * ре-рендериться при смене языка (это обеспечивает useTranslation).
 */
export function dateFnsLocale(): Locale {
  return i18n.language === 'en' ? enUS : ru
}
